var _effectorFileName = "/builds/gmini/front-ui-kit/src/Substrate/Substrate.tsx";
import { Wrapper } from './Substrate.styled';
import { jsx as _jsx } from "react/jsx-runtime";
export const Substrate = ({
  bgColor = 'rgba(53, 59, 96, 0.05)',
  borderRadius = 12,
  p = '13.5px',
  children
}) => /*#__PURE__*/_jsx(Wrapper, {
  borderRadius: borderRadius,
  bgColor: bgColor,
  p: p,
  children: children
});